import { createBasicSelector } from 'util/redux'
import { selectProps } from './selectProps'

export const selectIsMerging = createBasicSelector(
  selectProps,
  props => props.isMerging
)
